<template>
  <svg width="120px" height="60px" viewBox="0 0 120 60">
    <path
      d="M 8 60 A 16 15 0 0 1 112 60"
      fill="none"
      stroke="var(--primary-text)"
      opacity="0.2"
      stroke-width="10px"
    />
    <path
      d="M 8 60 A 16 15 0 0 1 112 60"
      fill="none"
      :stroke="strokeColor"
      stroke-width="10px"
      :stroke-dasharray="ARC_LENGTH"
      :stroke-dashoffset="value"
    />
  </svg>
</template>
<script>
import { computed, toRefs } from 'vue'

const ARC_LENGTH = 160

export default {
  props: {
    percent: {
      type: Number,
      required: true,
    },
    danger: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { percent, danger, success, warning } = toRefs(props)

    const value = computed(() => {
      const val = Math.max(
        0,
        Math.min(ARC_LENGTH, Math.floor(percent.value * ARC_LENGTH))
      )
      return ARC_LENGTH - val
    })

    const strokeColor = computed(() => {
      if (success.value) return 'var(--success)'
      if (warning.value) return 'var(--warning)'
      if (danger.value) return 'var(--danger)'
      return 'var(--primary-text)'
    })

    return {
      strokeColor,
      ARC_LENGTH,
      value,
    }
  },
}
</script>
